import { defineMessages } from '@atlassian/jira-intl';
import type { FlagConfiguration } from '../../../../services/types.tsx';

const messages = defineMessages({
	title: {
		id: 'platform.ui.flags.flags.errors.unauthorized.title',
		defaultMessage: "You're logged out",
		description: '',
	},
	description: {
		id: 'platform.ui.flags.flags.errors.unauthorized.description',
		defaultMessage: 'Log back in and try again.',
		description: '',
	},
});

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (): FlagConfiguration => ({
	type: 'error',
	title: messages.title,
	description: messages.description,
	messageId: 'flags.ui.configurations.errors.unauthorized.flag.error',
	messageType: 'transactional',
});
